import React, { useState } from 'react';
import { Tooltip, Popover, Box, useTheme } from '@mui/material';
import { Visibility, VisibilityOff, Layers } from '@mui/icons-material';
import { StyledMapButton, iconStyle } from './materialTheme/StyledMapComponents';
import '../../../static/styles/mapComponents.css';
import '../../../static/styles/dropdownMenu.css';

const DropdownMenu = ({ buttons }) => {
  const [isDropdownVisible, setDropdownVisible] = useState(null);
  const theme = useTheme();

  const toggleDropdownVisibility = (event) => {
    setDropdownVisible(isDropdownVisible ? null : event.currentTarget);
  };

  const handleButtonClick = (button) => {
    button.setActiveState(!button.activeState);
  };

  return (
    <>
      <Tooltip title="Layer Selector">
        <StyledMapButton
          onClick={toggleDropdownVisibility}
          className={`map-button-selector ${isDropdownVisible ? 'active' : ''}`}
          color='primary'
        >
          <Layers sx={iconStyle({ theme, isActive: isDropdownVisible })} />
        </StyledMapButton>
      </Tooltip>
      <Popover
        open={Boolean(isDropdownVisible)}
        anchorEl={isDropdownVisible}
        onClose={() => setDropdownVisible(null)}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'right',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
        TransitionProps={{
          timeout: { enter: 400, exit: 400 },
        }}
      >
        <Box
          sx={{
            background: 'none',
            display: 'flex',
            flexDirection: 'column',
          }}
        >
          {buttons.map((button, index) => (
            <Tooltip key={index} title={button.type}>
              <StyledMapButton
                variant="outlined"
                className={`map-button ${button.activeState ? 'active' : ''}`}
                onClick={() => handleButtonClick(button)}
              >
                {button.activeState ? (
                  <Visibility sx={iconStyle({ theme, isActive: true })} />
                ) : (
                  <VisibilityOff sx={iconStyle({ theme, isActive: false })} />
                )}
                <span style={{ marginLeft: '8px', marginRight: '8px' }}>
                  {button.type}
                </span>
              </StyledMapButton>
            </Tooltip>
          ))}
        </Box>
      </Popover>
    </>
  );
};

export default DropdownMenu;